// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___2ya5p"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/container/styles.css
// module id = keOT
// module chunks = 2